<template>
    <div class="cart-item__property property--processing-steps">
        <span class="property__label is-size-5">{{
            $t('processingSteps.label')
        }}</span>
        <div class="property__value">
            <div
                v-if="
                    cartItem.processingSteps &&
                    cartItem.processingSteps.length > 0
                "
                class="columns is-multiline is-gapless"
            >
                <div v-for="step in cartItem.processingSteps" class="mr-3">
                    <span class="property__value">{{ step.quantity }}</span> x
                    <span class="property__label">{{ step.option.name }}</span>
                </div>
            </div>
            <div v-else>
                {{ $t('processingSteps.noProcessingSteps') }}
            </div>
            <div class="has-text-right" v-if="isEditable">
                <button
                    class="button is-primary-dark"
                    @click="modalIsOpen = true"
                >
                    {{ $t('processingSteps.configureProcessingSteps') }}
                </button>
            </div>
        </div>
        <b-modal
            v-model="modalIsOpen"
            transition="expand"
            :full-screen="
                [viewports.MOBILE.name, viewports.TABLET.name].includes(
                    currentViewport
                )
            "
            :can-cancel="false"
        >
            <template #default="props">
                <configure-processing-steps
                    :cart-item-id="cartItem._id"
                ></configure-processing-steps>
            </template>
        </b-modal>
    </div>
</template>

<script>
import ConfigureProcessingSteps from './ConfigureProcessingSteps';
import ModalView from '../../shared/ModalView';
import { viewports } from '../../../store/constants/viewports';
import { mapGetters } from 'vuex';

export default {
    name: 'ItemProcessing',
    components: { ConfigureProcessingSteps, ModalView },
    data() {
        return {
            modalIsOpen: false,
            viewports,
        };
    },
    props: {
        cartItem: {
            type: Object,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: true,
        },
        showAttachments: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['currentViewport']),
    },
};
</script>

<style scoped></style>
